// Lightweight list of treatment slugs that have clinical content.
// Kept separate from condition-content.ts so nav/header code does not pull the
// entire (~200 KB) content dataset into every page bundle.
// Keep in sync with `treatmentClinicalContent` in src/lib/condition-content.ts.
export const treatmentContentSlugs = new Set<string>([
  "hemorrhoids-piles",
  "hernia-repair",
  "gallbladder-cholecystectomy",
  "circumcision",
  "varicose-veins",
  "gynecomastia-surgery",
  "appendectomy",
  "lipoma-removal",
  "anal-fissure",
  "anal-fistula",
  "all-types-of-delivery",
  "dandc-mtp-procedures",
  "ovarian-cystectomy",
  "endometrial-ablation",
  "laparoscopic-gynecology-surgery",
  "hysterectomy-surgery",
  "ectopic-pregnancy",
  "tubal-ligation",
  "joint-replacement",
  "implant-removal",
  "forearm-plating",
  "tendon-repair",
  "wound-debridement",
  "carpal-tunnel-release",
  "trigger-finger-surgery",
  "caudal-block",
  "pcnl-surgery",
  "ureteroscopy",
  "prostate-surgery",
  "turbt",
  "cystectomy",
  "urethroplasty",
  "tympanoplasty",
  "adenoidectomy",
  "septoplasty",
  "tonsillectomy",
  "nasal-bone-repair",
  "mastoidectomy",
  "cataract-surgery",
  "full-thickness-penetrating-keratoplasty-corneal-transplant",
  "vitrectomy",
  "vaginoplasty",
  "vaginal-tightening",
  "stress-urinary-incontinence",
  "genital-warts",
  "labiaplasty",
  "vaginal-prp",
  "hymen-reconstruction",
]);

export function hasTreatmentClinicalContent(slug: string): boolean {
  return treatmentContentSlugs.has(slug);
}
